import { render, staticRenderFns } from "./ClientShipment.vue?vue&type=template&id=ffafac48&"
import script from "./ClientShipment.vue?vue&type=script&lang=js&"
export * from "./ClientShipment.vue?vue&type=script&lang=js&"
import style0 from "./ClientShipment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports